<template>
  <div class="call-to-action-container">
    <h2 class="heading">{{ heading }}</h2>

    <p class="text">
      {{ text }}
    </p>
    <div class="cta-group">
      <slot name="cta"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CallToAction",
  props: {
    heading: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.call-to-action-container {
  background-color: $color-dark;
}
.heading {
  color: $color-white;
  padding: 40px 40px 10px;
  text-align: center;
  @include t__editorial-body-10;
}
.text {
  @include t__utility-label-20;
  color: $color-white;
  font-weight: 400;
  padding: 0 40px 20px;
  text-align: center;
  text-transform: none;
}
.cta-group {
  display: flex;
  column-gap: 15px;
  justify-content: center;
}
</style>
